<template lang="html">
	<div :class='`GoogleMap ${componentParams.template}`'>
		<bottom-map :data='api_response' v-if='componentParams.template == "bottom-map"'></bottom-map>
	</div>
</template>

<script>
module.exports = {
	name: 'GoogleMap',
	
	props: ['data-params'],
	
	data() {
		return {
			api_response: null
		}
	},
	
	computed: {
		componentParams() {
			let str = this.dataParams.replace(/'/g, '"');
			return JSON.parse(str);
		}
	},
	
	components: {
		'bottom-map': require('./maps/bottom.vue')
	},
	
	beforeMount() {
		let method = this.componentParams.method;
		let url = this.componentParams.url;
		let custom_request = this.componentParams.request;
		
		let options = {
			responseType: 'json'
		}
		
		if(method.toLowerCase() == 'post') {
			options.emulateJSON = true;
			this.$http[method](url, custom_request, options).then(success).catch(error);
		}
		else if(method.toLowerCase() == 'get') {
			options.params = custom_request;
			this.$http[method](url, options).then(success).catch(error);
		}
		
		function success(response) {
			// console.log(response);
			this.api_response = response.body.api_response;
		}
		
		function error(err) {
			console.log(err);
		}
	}
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// GoogleMap.vue?44694e71